export type Primitive = string | number | null | undefined | boolean;

export const primitiveToString = (v: Primitive): string => {
	if (v === null || v === undefined) {
		return "";
	} else {
		return v.toString();
	}
};
